// src/services/cofounder/tools/toolExecutor.js
import { getTool } from './ToolRegistry';

/**
 * Execute a tool call by name
 * @param {string} toolName - Name of the tool to execute
 * @param {Object} args - Tool arguments
 * @param {Object} context - Execution context { userProfile, activeBusiness, currentUser }
 * @returns {Promise<any>}
 */
export async function executeToolCall(toolName, args, context) {
  const tool = getTool(toolName);
  if (!tool) {
    throw new Error(`Tool "${toolName}" not found in registry`);
  }
  return await tool.execute(args || {}, context);
}
